import * as Yup from "yup";

import { DEFAULT_SIGNUP_REQUIRED } from "./constants";

const REQUIRED_FIELD_MESSAGE = "Поле обязательно для заполнения.";

const password = Yup.string()
  .matches(/^.{6,}$/, {
    message: "Минимальная длина пароля 6 символов.",
    excludeEmptyString: true,
  })
  .required(REQUIRED_FIELD_MESSAGE);

const passwordConfirm = Yup.string()
  .oneOf([Yup.ref("password1"), null], "Пароли не совпадают, повторите ввод.")
  .required(REQUIRED_FIELD_MESSAGE);

export const createSignUpValidationSchema = (required = DEFAULT_SIGNUP_REQUIRED) => {
  const schema: Record<string, Yup.StringSchema> = {};

  if (required?.password) {
    schema.password1 = password;
    schema.password2 = passwordConfirm;
  }

  if (required?.email) {
    schema.email = Yup.string().email("Проверьте правильность введённого email.").required(REQUIRED_FIELD_MESSAGE);
  }

  if (required?.username) {
    schema.username = Yup.string()
      .matches(/^[A-Za-z0-9_]+$/, {
        message: "Логин должен содержать только латинские буквы, цифры и знак подчеркивания",
        excludeEmptyString: true,
      })
      .required(REQUIRED_FIELD_MESSAGE);
  }

  if (required?.familyName) {
    schema.familyName = Yup.string().required(REQUIRED_FIELD_MESSAGE);
  }

  if (required?.name) {
    schema.name = Yup.string().required(REQUIRED_FIELD_MESSAGE);
  }

  if (required?.surname) {
    schema.surname = Yup.string().required(REQUIRED_FIELD_MESSAGE);
  }

  if (required?.company) {
    schema.company = Yup.string().required(REQUIRED_FIELD_MESSAGE);
  }

  if (required?.phone) {
    schema.phone = Yup.string().required(REQUIRED_FIELD_MESSAGE);
  }

  if (required?.goals) {
    schema.goals = Yup.string().required(REQUIRED_FIELD_MESSAGE);
  }

  return Yup.object().shape(schema);
};
